export default __webpack_public_path__ + "static/media/frys.f5cd2217.jpg";